import {
  Business,
  BusinessUnit,
  PurchaseOrder,
  PurchaseOrderItem,
  Tender,
  TenderType,
} from 'lib/types/models';
import { Pagination } from 'lib/types/shared';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getSupplierTenders = async (
  dispatch: Dispatch,
  identifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/publicMarket/supplier/${identifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getTenderDetails = async (
  dispatch: Dispatch,
  tenderId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/publicMarket/tender/${tenderId}`,
    dispatch,
  });
  if (response) return response.data;
};

export interface PurchaseOrderDetailsResponse extends PurchaseOrder {
  items: PurchaseOrderItem[];
  buyer: Business;
  supplier: Business;
  buyerUnit: BusinessUnit;
  supplierUnit: BusinessUnit;
}

export const getPurchaseOrderDetails = async (
  dispatch: Dispatch,
  purchaseOrderId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/publicMarket/purchaseOrder/${purchaseOrderId}`,
    dispatch,
  });
  if (response) return response.data as PurchaseOrderDetailsResponse;
};

export interface SummaryResponse {
  amountTraded: number;
  tenderQuantity: number;
  buyers: Business[];
  suppliers: Business[];
  tenderByType: Record<TenderType, number>;
  tenderByStatus: Record<string, number>;
  tenders: Tender[];
  publishedTendersClosingSoon: {
    today: number;
    in3Days: number;
    in1Week: number;
    in1MonthOrMore: number;
  };
  closingSoonTendersAmount: number;
  awardedTenders: Record<string, { quantity: number; amount: number }>;
  notAwardedTendersAmount: number;
  top10BuyersByAwardedAmount: Record<string, number>;
  top10SuppliersByAwardedAmount: Record<string, number>;
  top10CategoriesByAwardedAmount: Record<string, number>;
}

export const getGeneralData = async (dispatch: Dispatch, query?: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/publicMarket/general?${query}`,
    dispatch,
  });
  if (response) return response.data as SummaryResponse;
};

export const getTenders = async (dispatch: Dispatch, query?: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/publicMarket/tenders?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export interface PurchaseOrdersResponse {
  data: PurchaseOrder[];
  pagination: Pagination;
}

export const getPurchaseOrders = async (dispatch: Dispatch, query?: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/publicMarket/purchaseOrders?${query}`,
    dispatch,
  });
  if (response) return response.data as PurchaseOrdersResponse;
};

export const generateLead = async (
  dispatch: Dispatch,
  data: {
    businessIdentifier: string;
    productTypeId: string;
    executiveId: number;
    enrolledPath?: string;
  },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/publicMarket/lead`,
    dispatch,
    data,
  });
  if (response) return response.data;
};
